
export function successfulLoginEvent() {
  return {
    type: 'xtract-auth@successful-login-event'
  }
}

export function lockUserAccount(userId, callbacks) {
  return {
    type: 'xtract-auth@lock-user-account',
    user_id: userId,
    callbacks
  }
}

export function unlockUserAccount(userId, callbacks) {
  return {
    type: 'xtract-auth@unlock-user-account',
    user_id: userId,
    callbacks
  }
}

/**
 * clears this.props.auth.token Currently leaves username intact so that it
 * can be used to pre-populate the username login field.
 */
export function doLogout() {
  return {
    type: 'xtract-auth@logout'
  }
}

export function verifyEmail(callbacks) {
  return {
    type: 'xtract-auth@verify-email',
    callbacks
  }
}

export function resendVerificationEmail(userId, callbacks) {
  return {
    type: 'xtract-auth@resend-verify-email',
    userId,
    callbacks
  }
}

export function doTokenRefresh(retryAction = null) {
  return {
    type: 'xtract-auth@auth-token-refresh',
    action: retryAction
  }
}

export function startTokenRefresh() {
  return { type: 'xtract-auth@start-token-refresh' }
}

export function storeRefresherHandle(handle) {
  return { type: 'xtract-auth@store-refresher-handle', handle }
}

export function clearRefresherHandles() {
  return { type: 'xtract-auth@clear-refresher-handles' }
}

export function cancelTokenRefresh() {
  return { type: 'xtract-auth@cancel-token-refresh' }
}

export function verifyPassword(password, callbacks = {}) {
  return { type: 'xtract-auth@verify-password', password, callbacks }
}

export function setToken(argsObj = {}) {
  const {
    token,
    refreshTimer,
    refreshToken,
    privilege,
    inactivityTimeout,
    username,
    user_id
  } = argsObj
  return {
    type: 'xtract-auth@set-token',
    token,
    refreshTimer,
    refreshToken,
    privilege,
    inactivityTimeout: inactivityTimeout,
    username,
    user_id
  }
}

export function handleUserAlerts() {
  return { type: 'xtract-auth@handle-user-alerts' }
}

export function getAuthCodeToken(query, subProvider, authProvider, errorHandler, successFilter = () => true) {
  return { type: 'xtract-auth@get-auth-code-token', errorHandler, query, subProvider, authProvider, successFilter }
}

export function attemptLogin(displayname, password, callbacks) {
  return { type: 'xtract-auth@attempt-login', displayname, password, callbacks }
}

export function requestPasswordReset(email, callbacks) {
  return {
    type: 'xtract-auth@request-password-reset',
    email,
    callbacks
  }
}

export function resetPassword(
  password,
  passwordConfirmation,
  callbacks = {}
) {
  return {
    type: 'xtract-auth@password-reset',
    password,
    passwordConfirmation,
    callbacks
  }
}
